import React from "react";

const ArticleSkeleton = () => {
  return (
    <div className="animate-pulse h-[340px] w-[290px] rounded-[24px]">
      <div className="flex flex-col items-center justify-between bg-gray-400 h-full p-2 rounded-[24px]">
        <div className="h-[146px] bg-gray-200 rounded-[24px] w-[272px]" />
        <div className="flex flex-col gap-2 mb-6">
          <div className="h-[16px] bg-gray-200 rounded-[6px] w-[140px]" />
          <div className="h-[16px] bg-gray-200 rounded-[6px] w-[260px]" />
          <div className="h-[16px] bg-gray-200 rounded-[6px] w-[210px]" />
          <div className="h-[16px] bg-gray-200 rounded-[6px] w-[180px]" />
        </div>
      </div>
    </div>
  );
};

export default ArticleSkeleton;
